import * as R from "ramda"

// Currently, apollo does not strips __typename field from the Query response
// therefore it needs to be done manually in order to do a Mutation
export const omitTypename = R.map(R.omit(["__typename"]))
